import PropertyPathHelper from '@/utils/PropertyPathHelper';
import BaseRedirectAction from './base-redirect.action';
import { ActionName, ActionTitle } from '../enums';
import { track } from '@/utils/analytics';
import { SoldDataEvent } from '@/constants/AnalyticEvents';
import routes from '@/constants/routes';

export default class ViewSoldPropertyAction extends BaseRedirectAction {
  name = ActionName.ViewSoldProperty;
  title = ActionTitle.ViewSoldDetails;

  // eslint-disable-next-line class-methods-use-this
  getLink(listing) {
    const isSoldDataPage = window.location.pathname === routes.soldData;

    if (isSoldDataPage) {
      track(SoldDataEvent.MapSoldPropertyCardClick);
    }

    return PropertyPathHelper.generateSoldRouteFromListing(listing);
  }
}
